
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import BeforeAfter from './components/BeforeAfter';
import Contact from './components/Contact';
import Reviews from './components/Reviews';
import Gallery from './components/Gallery';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Services />
      <BeforeAfter />
      <Contact />
      <Reviews />
      <Gallery />
      <Footer />
    </div>
  );
}
